import { SearchOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Input, Typography, Spin, Button } from "antd";
import axios from "axios";
import { useToast } from "../../../../contexts/ToastContext";

const { Title } = Typography;

const SearchCar = ({
    selectedCompany,
    setSelectedCompany,
    setStep,
    t, // Translation function
    setIsManualCarAddMode,
}) => {
    const toast = useToast();
    const [search, setSearch] = useState("");
    const [companies, setCompanies] = useState([]);
    const [companyLoading, setCompanyLoading] = useState(false);

    useEffect(() => {
        const handleFetchCarCompanies = async () => {
            try {
                setCompanyLoading(true);
                const { data } = await axios.get(
                    "https://public.opendatasoft.com/api/records/1.0/search/?sort=modifiedon&rows=0&facet=make&dataset=all-vehicles-model&lang=en",
                );

                if (data?.facet_groups?.[0]?.facets?.length > 0) {
                    setCompanies(data.facet_groups[0].facets);
                }
            } catch (_error) {
                toast.error({ message: t("failedToFetchCompanies") });
            } finally {
                setCompanyLoading(false);
            }
        };

        handleFetchCarCompanies();
    }, [toast, t]);

    const handleSelectCompany = (companyName) => {
        setSelectedCompany(companyName);
        setStep((prev) => prev + 1);
    };

    const filteredCompanies = companies.filter((company) =>
        // eslint-disable-next-line implicit-arrow-linebreak
        company.name.toLowerCase().includes(search.toLowerCase()),
    );

    return (
        <div className="p-8 max-h-[80vh] overflow-y-auto">
            <div className="flex justify-center items-center gap-4 flex-col mb-8">
                <div className="flex justify-center items-center flex-col">
                    <Title level={3} className="m-0 p-0">
                        {t("searchForAddNewCar")}
                    </Title>
                    <div className="text-gray-500 text-sm mb-3">{t("searchForAddNewCarDescription")}</div>
                </div>
                <Button onClick={() => setIsManualCarAddMode(true)}>{t("addCarManuallyBtn")}</Button>
            </div>
            <Input
                size="large"
                prefix={<SearchOutlined className="text-gray-400" />}
                placeholder={t("searchCompanyPlaceholder")}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="mb-6 rounded-lg bg-gray-50 border border-gray-200"
            />
            <div className="mb-4 font-medium">{t("carsCompanyList")}</div>
            <div className="text-gray-500 text-sm mb-3">{t("selectYourCompany")}</div>
            {companyLoading ? (
                <div className="flex justify-center items-center h-full w-full">
                    <Spin size="large" />
                </div>
            ) : (
                <div className="mb-7 max-h-80 overflow-y-auto grid grid-cols-5 gap-4">
                    {filteredCompanies.map((company) => (
                        <div key={company.name}>
                            <button
                                type="button"
                                className={`flex items-center gap-2 rounded-lg font-medium text-[15px] transition-all whitespace-normal text-left w-36 overflow-hidden  ${
                                    selectedCompany === company.name ? " bg-blue-100 !font-bold" : ""
                                }`}
                                style={{
                                    padding: "8px 12px",
                                    lineHeight: "1.2",
                                }}
                                onClick={() => handleSelectCompany(company.name)}>
                                <span className="truncate">{company.name}</span>
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

SearchCar.propTypes = {
    selectedCompany: PropTypes.string.isRequired,
    setSelectedCompany: PropTypes.func.isRequired,
    setStep: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    setIsManualCarAddMode: PropTypes.func.isRequired,
};

export default SearchCar;
